export function initNavigation() {
  const buttons = document.querySelectorAll('button[data-action="toggle-menu"]');

  function showNavMenu(event) {
    const { target } = event;
    const btn = target.closest('.peer');
    btn.classList.toggle('open');
  }

  if (buttons) {
    buttons.forEach((btn) => {
      btn.addEventListener('click', showNavMenu);
    });
  }
}
